import { LoadingComponent } from '@amzn/event-engine-js-utils';

export default LoadingComponent;
